import React, { useEffect, useState } from "react";
import ColorSelector from "../../../../../CommonComponents/ColorSelector/ColorSelector";
import "./AppColorPreview.css";
import { PersonIcon } from "../../../../../utils/icons";
import PreviewClubCard from "./PreviewClubCard";
import { rgbaToHex } from "../../../../../utils/colors";

const AppColorPreview = ({
  colors,
  handleColorChange,
  isLogoTransparent,
  logoImage,
  preview,
  primaryColor,
  secondaryColor,
  groupName,
}) => {
  const getLogoUrl = () => {
    if (preview) {
      return preview;
    }

    if (logoImage && logoImage.length > 0) {
      return logoImage[0].url || logoImage[0].thumbUrl;
    }
    return null;
  };

  const getHexColor = (color) => {
    // Handle undefined, null, or invalid color objects
    if (!color || typeof color !== "object") {
      return "#000000"; // Default black
    }

    const { r = 0, g = 0, b = 0, a = 1 } = color;

    // Validate that values are numbers
    if (
      typeof r !== "number" ||
      typeof g !== "number" ||
      typeof b !== "number"
    ) {
      return "#000000"; // Default black
    }

    return rgbaToHex(r, g, b, a);
  };

  const [primaryHex, setPrimaryHex] = useState(getHexColor(primaryColor));
  const [secondaryHex, setSecondaryHex] = useState(getHexColor(secondaryColor));

  const colorChangeHandler = (color, type) => {
    handleColorChange(color, type);

    if (type === "primaryColor") {
      setPrimaryHex(color);
    } else {
      setSecondaryHex(color);
    }
  };

  // Update colors when props change
  useEffect(() => {
    setPrimaryHex(getHexColor(primaryColor));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primaryColor]);

  useEffect(() => {
    setSecondaryHex(getHexColor(secondaryColor));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryColor]);

  return (
    <div className="app-color-preview-body">
      <div className="app-color-preview-pickers">
        <div>
          <h6 style={{ fontWeight: "bold" }}>Primary Color</h6>{" "}
          <p style={{ color: "#666666" }}>
            (App splash screen / header, Web header)
          </p>
          <div>
            <ColorSelector
              colors={colors.filter((color) => color !== "#FFFFFF")}
              colorHex={primaryHex}
              colorChangeHandler={(color) =>
                colorChangeHandler(color, "primaryColor")
              }
            />
          </div>
        </div>

        <div className="app-color-preview-secondary">
          <h6 style={{ fontWeight: "bold" }}>Secondary Color</h6>{" "}
          <p style={{ color: "#666666" }}>(Card accents)</p>
          <div>
            <ColorSelector
              colors={colors}
              colorHex={secondaryHex}
              colorChangeHandler={(color) =>
                colorChangeHandler(color, "secondaryColor")
              }
            />
          </div>
        </div>
      </div>

      <div className="app-color-preview-preview">
        <h6
          style={{
            textAlign: "center",
            width: "360px",
            paddingBottom: "6px",
            fontWeight: "400",
          }}
        >
          App Preview
        </h6>
        <div
          className="group-color-selector-preview"
          style={{ background: secondaryHex }}
        >
          <div
            className="group-color-selector-preview-header"
            style={{
              background: `linear-gradient(to bottom, ${primaryHex},color-mix(in srgb, ${primaryHex} 80%, black))`,
            }}
          >
            <div className="group-color-selector-preview-header-container">
              <div className="group-color-selector-preview-title-container">
                <div className="app-color-preview-center">
                  {getLogoUrl() ? (
                    isLogoTransparent ? (
                      <img
                        className="group-color-selector-preview-logo"
                        src={getLogoUrl()}
                        alt=""
                      />
                    ) : (
                      <div className="group-color-selector-preview-logo-container">
                        <img
                          className="group-color-selector-preview-logo"
                          src={getLogoUrl()}
                          alt=""
                        />
                      </div>
                    )
                  ) : (
                    <div className="group-color-selector-preview-logo-container">
                      <div className="group-color-selector-preview-logo-placeholder">
                        No Logo
                      </div>
                    </div>
                  )}
                </div>

                <p className="group-color-selector-preview-title">
                  {groupName || "Group Name"}
                </p>
              </div>

              <div className="app-color-preview-center group-color-selector-preview-login">
                <img src={PersonIcon} alt="" />
              </div>
            </div>
          </div>

          <div className="group-color-selector-preview-body">
            <div className="group-color-selector-preview-body-container">
              {Array(3)
                .fill(0)
                .map((_, index) => (
                  <PreviewClubCard
                    key={index}
                    mapIndex={index}
                    primaryHex={primaryHex}
                    secondaryHex={secondaryHex}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppColorPreview;
